import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  expectedArrivalTime: () => faker.date.future(),
  name: () => faker.commerce.productName(),
  flowName: 'Delivery',

  withEmployee: trait({
    afterCreate(meeting, server) {
      meeting.update({
        employee: server.schema.create('employee'),
      });
    },
  }),
});
